<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="12" :class="{ 'pb-0': !isEditing }">
        <span class="subtitle-1">
          {{ $t('transporterConfiguration') }}
          <Icon v-if="!isEditing"
            icon="transporter"
            :small="false"
            style="margin-top: -5px; vertical-align: middle;"/>
        </span>
      </v-col>
    </v-row>
    <v-row :class="{ 'mt-0': !isEditing }">
      <v-col cols="12" class="py-1">
        <v-switch
          v-model="localTransporterByproductTickets"
          @change="val => $emit('updateTransporterByproductTickets', val)"
          :label="$t('transporterByproductTicketCreation')"
          hide-details="auto"
          :readonly="!isEditing"/>
      </v-col>
      <v-col cols="12" class="py-1" v-if="localTransporterByproductTickets || !isEditing">
        <v-switch
          v-model="location.hideByproductPickupContractsInTransporter"
          :label="$t('hideByproductPickupContracts')"
          hide-details="auto"
          :readonly="!isEditing"/>
      </v-col>
      <v-col cols="12" class="py-1" v-if="localTransporterByproductTickets || !isEditing">
        <v-switch
          v-model="location.allowTransporterDepartureWeightEntry"
          :label="$t('transporterDepartureWeightEntry')"
          hide-details="auto"
          :readonly="!isEditing"/>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'TransporterConfig',

  props: {
    isEditing: {
      type: Boolean,
      required: true
    },
    transporterByproductTickets: {
      type: Boolean,
      required: true
    },
    location: {
      type: Object,
      required: true
    }
  },

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  created () {
    this.localTransporterByproductTickets = this.transporterByproductTickets
  },

  data: () => ({
    localTransporterByproductTickets: false
  }),

  watch: {
    transporterByproductTickets (newVal) {
      this.localTransporterByproductTickets = newVal
    }
  }
}
</script>
